var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1073.36 699.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#707070;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "laptop-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1102.88,882.53H96.85a33.64,33.64,0,0,0,0,67.27h1006a33.64,33.64,0,1,0,0-67.27Z",
    transform: "translate(-63.3 -250.15)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.05,852.81H1004.9a33.51,33.51,0,0,0,33.56-33.5V283.7a33.49,33.49,0,0,0-33.56-33.55H195.05a33.35,33.35,0,0,0-33.56,33.55V819.31a33.36,33.36,0,0,0,33.55,33.5Zm33.56-535.33H971.18V785.76H228.61Z",
    transform: "translate(-63.3 -250.15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopIcon);
export default __webpack_public_path__ + "static/media/laptop-icon.09ebe2823df66c5d2e1bcbba82bb7aaa.svg";
export { ForwardRef as ReactComponent };